import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme.js';
import { connect } from 'react-redux';

import { request, guid, mapStateToProps, mapDispatchToProps } from '../../utils';
import { fetchArticleBySlug } from '../../actions/content';

import Body from '../../components/Body';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import InterviewHero from '../../components/InterviewHero';
import InterviewTextArea from '../../components/InterviewTextArea';
import InterviewImage from '../../components/InterviewImage';
import InterviewYouTubeVideo from '../../components/InterviewYouTubeVideo';
import InterviewImageWithText from '../../components/InterviewImageWithText';
import ArticleSocialLinks from '../../components/ArticleSocialLinks';
import ContentContainer from '../../components/ContentContainer';
import HorizontalRule from '../../components/HorizontalRule';
import FilterControl from '../../components/FilterControl';
import ArticleSummary from '../../components/ArticleSummary';
import Paragraph from '../../components/Paragraph';
import SocialLink from '../../components/SocialLink';
import Loading from '../../components/Loading';

import FeaturedArticles from '../../components/FeaturedArticles';
import ArticleAd from '../../components/ArticleAd';

class Article extends Component {
  constructor(props) {
    super(props);
    const post = this.getPost();
    this.state = {
      post: post,
      loaded: post !== false,
    };
  }

  componentWillUpdate(nextProps, nextState) {
    // Currently on Article, has clicked another Article so the component does not unmount.
    if(this.state.post && this.state.post.id && (nextProps.location.state && nextProps.location.state.post.id !== this.state.post.id)) {
      this.setState({
        post: nextProps.location.state.post
      });
    }
  }

  getPost() {
    if(this.props.location.state && this.props.location.state.post) {
      // Has come via react-router-dom Link
      return this.props.location.state.post;
    } else if(!this.props.location.state || !this.props.location.state.post) {
      // Freshly loaded
      this.props.dispatch(fetchArticleBySlug(this.props.match.params.slug)).then((response) => {
        const post = response.data.posts[0];
        this.setState({
          post: post,
          loaded: true,
        });
      }, (err) => {
        this.props.history.push("/404");
      });

      return false;
    }
  }

  getFeaturedPosts() {
    // Get the 3 most recent posts in the same category which are not the current post
    if(this.props && this.props.content && this.props.content.posts) {
      return this.props.content.posts.filter((post) => {
        return ((post.id !== this.state.post.id) && (post.featured));
      }).slice(0,3);
    }

    return false;
  }

  getRelatedPosts() {
    let relatedPosts = [];

    // Get the 3 most recent posts in the same category which are not the current post
    if(this.props && this.props.content && this.props.content.posts) {
      relatedPosts = this.props.content.home.posts.filter((post) => {
        return (post.id !== this.state.post.id);
      }).slice(0,3).map((post) => {
        return (
          <ArticleSummary
            key={`${post.id}_${post.slug}`}
            post={post} />
        );
      });
    }

    // Fallback to 3 most recent on homepage if none in category
    if(!relatedPosts.length) {
      relatedPosts = this.props.content.posts.filter((post) => {
        return ((post.id !== this.state.post.id) && (post.category === this.state.post.category));
      }).slice(0,3).map((post) => {
        return (
          <ArticleSummary
            key={`${post.id}_${post.slug}`}
            post={post} />
        );
      });
    }

    return relatedPosts;
  }

  render() {
    if(!this.state.post) {
      return (
        <div />
      );
    }

    const relatedPosts = this.getRelatedPosts();
    const featuredArticles = this.getFeaturedPosts();

    return (
      <Body
        title={this.state.post.meta_title ? this.state.post.meta_title : `${this.state.post.title} - Sniffers`}
        description={this.state.post.meta_desc ? this.state.post.meta_desc : false}
        player={this.props.player}
        history={this.props.history}
        search={this.props.search}
        dispatch={this.props.dispatch}>
        <Header content={this.props.content} dispatch={this.props.dispatch} />
        {
          this.state.loaded ? (
            <div>
              <InterviewHero
                dispatch={this.props.dispatch}
                image={this.state.post.hero_image_url}
                title={this.state.post.title}
                date={this.state.post.published}
                track={this.state.post.track_info}
                category={this.state.post.category} />
              <ContentContainer>
                <div className={css(styles.content_container)}>
                  {
                    this.state.post.blocks.map((block) => {
                      switch(block.type) {
                        default:
                          return false;
                        case 'text_area':
                          return (
                            <InterviewTextArea content={block.fields.text_area} />
                          );
                        case 'large_image':
                          return (
                            <InterviewImage src={block.fields.image} />
                          );
                        case 'youtube_video_url':
                          return (
                            <InterviewYouTubeVideo vid={block.fields.youtube_url} />
                          );
                        case 'image_with_text':
                          return (
                            <InterviewImageWithText
                              count={block.count}
                              text={block.fields.text}
                              image={block.fields.image} />
                          );
                      }
                    })
                  }
                  <ArticleSocialLinks
                    title={this.state.post.title}
                    url={`http://sniffers.co.nz/${this.props.content_type}/${this.state.post.slug}`} />
                  {
                    relatedPosts && relatedPosts.length ? (
                      <div>
                        <HorizontalRule />
                        <div className={css(styles.section_title)}>
                          Also worth a sniff
                        </div>
                        <div className={css(styles.articles_container)}>
                          { relatedPosts }
                        </div>
                      </div>
                    ) : false
                  }
                </div>
              </ContentContainer>
              <Footer />
            </div>
          ) : (
            <Loading />
          )
        }
      </Body>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Article);

const styles = StyleSheet.create({
  content_container: {
    display: 'flex',
    paddingTop: 40,
    paddingBottom: 20,
    flexDirection: 'column',
    width: Theme.container_width - 200,
    margin: '0 auto',
    [Theme.mobile_query]: {
      width: '100%',
      flexDirection: 'column',
    },
  },
  section_title: {
    fontFamily: Theme.fontFamily,
    fontWeight: 900,
    color: Theme.dark_grey,
    letterSpacing: 2,
    fontSize: 10,
    textTransform: 'uppercase',
    [Theme.mobile_query]: {
      textAlign: 'center',
    },
  },
  articles_container: {
    marginTop: 40,
    marginBottom: 100,
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: "wrap"
  },
  contributor_section: {
    display: 'flex',
    width: '100%',
    margin: '20px auto',
    alignItems: 'center',
  },
  contributor_image_container: {
    flex: 2,
  },
  contributor_image: {
    maxWidth: 100,
    maxHeight: 100,
    borderRadius: 50,
  },
  contributor_info_container: {
    flex: 7,
    [Theme.mobile_query]: {
      paddingLeft: 30,
    },
  },
  contributor_name: {
    fontFamily: Theme.fontFamily,
    fontWeight: '500',
    fontSize: 14,
  },
  contributor_bio: {
    marginTop: 20,
  },
  contributor_social_links: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginLeft: -30,
  },
});



// WEBPACK FOOTER //
// ./src/views/Interview/index.js